/* eslint-disable */
import { Address } from '../models/address.model';

export const mockDeliveryAddress: Address = {
  address_line_1: '123, GEORGIA ROAD',
  address_line_2: 'London',
  address_line_3: undefined,
  address_line_4: undefined,
  postal_code: 'CR7 8DU',
  country_code: 'GB',
};
